// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1TFSL","gfeWrapper":"CalendarEvent_gfeWrapper__FeO9D"};